import { useEffect, useMemo } from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import Flex from 'components/common/Flex';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { AppTheme, Colors } from 'styles/theme';
import Banner from './common/Banner';
import OneApp from './common/OneApp';
import IntroSwiper from './common/IntroSwiper';
import Features from './common/Features';
import Freelows from './common/Freelows';
import Utility from './common/Utility';
import Questions from './common/Questions';
import Footer from './common/Footer';
import PageFooter from 'components/Footer';
import Header from 'components/Header'
import useDepsContainer from 'hooks/useDepsContainer'

interface HomePageProps {}

const HomePage = (props: HomePageProps) => {
  const styles = useStyles(props);
  const history = useHistory();
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  const { uiStore } = useDepsContainer();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const cid = urlParams.get('cid');
    if(cid){
      history.push(`/${cid}`);
    }
  }, [])

  return (
    <Flex width="100vw" className={styles.pageContainer} bgcolor={'#FFF'} column lang={uiStore.language}>
      <Flex position={'absolute'} top={0} left={0} width={'100%'} style={{ padding: mdDown ? 0 : '0 24px' }}>
        <Header bgcolor={'rgba(255, 255, 255)'} />
      </Flex>
      <Banner />
      {/* <Flex mb={mdDown ? 13 : 26}><OneApp /></Flex> */}
      <IntroSwiper />
      <Flex py={10} mt={mdDown ? 0 : 0} className={styles.features}>
        <Features />
      </Flex>
      <Freelows />
      <Flex py={mdDown ? 10 : 20}>
        <Utility />
      </Flex>
      <Flex py={mdDown ? 10 : 10}>
        <Questions />
      </Flex>
      <Footer />
      <Flex>
        <PageFooter isHome />
      </Flex>
    </Flex>
  );
};

const useStyles = makeStyles((theme: AppTheme) =>
  createStyles({
    pageContainer: {
      overflowX: 'hidden',
      overflowY: 'auto',
      background: '#FFF',
      fontFamily: "'Nohemi', sans-serif !important",

      '&[lang="vn"]': {
        fontFamily: "'Work Sans', sans-serif !important",
        letterSpacing: '-.5px'
      }
    },
    features: {
      background: '#FDEBE7'
    }
  })
);

export default observer(HomePage);
